module.exports = __webpack_public_path__ + "static/image003-ac752416300927e6f2a1e2862b6b12c0.jpg";